import {BaseModel} from '@/core/standard/BaseModel';
import {IScreenModel, IScreens, ScreenProtocol} from '@/modules/screens/IScreenModel';
import ScreenService from '@/modules/screens/ScreenService';


const screen = {
  name: '',
  categories: '',
  tpv: null,
  show_various: false,
  modifiers: [],
};

class ScreenModel extends BaseModel<IScreenModel, ScreenProtocol, typeof ScreenService> {
  public modelName = 'Mesa';

  public request = 'JSON';

  constructor() {
    super(screen, ScreenService);
  }

  public async getByTpv(query: ScreenProtocol): Promise<any> {
    return this.service.getByTpv(query);
  }
}

export default ScreenModel as new() => IScreens;
